import { addDays, format } from 'date-fns'

/**
 * Get the next delivery date based on Monday and Thursday
 */
export const getNextDeliveryDate = () => {
  const today = new Date()
  const dayOfWeek = today.getDay()
  const daysMap = [1, 1, 2, 4, 4, 1, 1, 1] // 1 = Monday, 2 = Tuesday, 4 = Thursday
  const targetDay = daysMap[dayOfWeek]
  const daysUntilNext = (targetDay - dayOfWeek + 7) % 7
  const nextDate = addDays(today, daysUntilNext)

  return format(nextDate, 'yyyy-MM-dd')
}